<template>
	<widget :height="height" :loading="loading">
		<vue-apex-charts class="mt-2" width="100%" :height="height" type="donut" :options="options" :series="series" />
	</widget>
</template>

<script>
import Widget from './Widget';
import VueApexCharts from 'vue-apexcharts';

export default {
	components: {
		Widget,
		VueApexCharts
	},
	props: {
		id: { defualt: 'online-devices-client' },
		clients: {
			type: Array,
			default () {
				return [];
			}
		},
		height: { default: '160' },
		header: { default: null },
		clientField: {
			type: String,
			required: true
		}
	},
	computed: {
		options () {
			return {
				chart: {
					id: this.id
				},
				labels: this.labels,
				title: {
					text: this.headerText,
					offsetX: 0,
					style: {
						fontSize: '18px',
						fontWeight: 'normal'
					}
				}
			};
		},
		headerText () {
			if (this.header === null) {
				return 'Device Status by Client';
			}

			return this.header;
		},
		labels () {
			const clientArray = [];

			for (const client of this.clients) {
				clientArray.push(client.name);
			}

			return clientArray;
		},
		series () {
			const onlineArray = [];

			for (const client of this.clients) {
				onlineArray.push(client[this.clientField]);
			}

			return onlineArray;
		},
		loading () {
			return this.clients.length === 0;
		}
	}
};
</script>

<style scoped>

</style>
